import { NavConfigItem } from '../types';

/**
 * Structure and routing for side navigation
 */
export const NAV_SECTIONS: NavConfigItem[] = [
  // Overview
  { label: 'Ink Overview', id: 'overview', route: ['/overview'] },
  { type: 'Divider' },
  // Foundations
  {
    title: 'Foundations',
    id: 'foundations',
    route: ['/foundations'],
    children: [
      { label: 'Colors', id: 'colors', route: ['/foundations/colors/tokens', '/foundations/colors/usage'] },
      {
        label: 'Typography',
        id: 'typography',
        route: [
          '/foundations/typography/tokens',
          '/foundations/typography/usage',
          '/foundations/typography/subcomponents',
        ],
      },
      { label: 'Radii', id: 'radii', route: ['/foundations/radii'] },
      { label: 'Elevation', id: 'elevation', route: ['/foundations/elevation'] },
      { label: 'Spacing', id: 'spacing', route: ['/foundations/spacing/usage', '/foundations/spacing/subcomponents'] },
      { label: 'Layout', id: 'layout', route: ['/foundations/layout/usage', '/foundations/layout/subcomponents'] },
      {
        label: 'Icons',
        id: 'icons',
        route: ['/foundations/icons/usage', '/foundations/icons/icon-library', '/foundations/icons/subcomponents'],
      },
      {
        label: 'Illustrations',
        id: 'illustrations',
        route: [
          '/foundations/illustrations/usage',
          '/foundations/illustrations/illustrations-library',
          'foundations/illustrations/subcomponents',
        ],
      },
      { label: 'Brand', id: 'brand', route: ['https://brand.carta.com/document/58#/-/brand-assets'], target: '_blank' },
    ],
  },
  // Components
  {
    title: 'Components',
    id: 'components',
    route: ['/components'],
    children: [
      {
        title: 'Buttons',
        id: 'buttons',
        route: ['/categories/buttons'],
        items: [
          { label: 'Anchor', id: 'anchor', route: ['/components/Anchor/usage', '/components/Anchor/code'] },
          { label: 'Button', id: 'button', route: ['/components/Button/usage', '/components/Button/code'] },
          {
            label: 'ButtonGroup',
            id: 'button-group',
            route: [
              '/components/ButtonGroup/usage',
              '/components/ButtonGroup/code',
              '/components/ButtonGroup/subcomponents',
            ],
          },
          { label: 'Favorite', id: 'favorite', route: ['/components/Favorite/usage', '/components/Favorite/code'] },
          {
            label: 'FooterActions',
            id: 'footer-actions',
            route: ['/components/FooterActions/usage', '/components/FooterActions/code'],
          },
        ],
      },
      {
        title: 'Containers',
        id: 'containers',
        route: ['/categories/containers'],
        items: [
          { label: 'Accordion', id: 'accordion', route: ['/components/Accordion/usage', '/components/Accordion/code'] },
          { label: 'Block', id: 'block', route: ['/components/Block/usage', '/components/Block/code'] },
          {
            label: 'FullPageModal',
            id: 'full-page-modal',
            route: ['/components/FullPageModal/usage', '/components/FullPageModal/code'],
          },
          {
            label: 'Modal',
            id: 'modal',
            route: [
              '/components/Modal/usage',
              '/components/Modal/code',
              '/components/Modal/subcomponents',
              '/components/Modal/migration-guide',
            ],
          },
          {
            label: 'Tile',
            id: 'tile',
            route: ['/components/Tile/usage', '/components/Tile/code', '/components/Tile/subcomponents'],
          },
          {
            label: 'Traceback',
            id: 'traceback',
            route: ['/components/Traceback/code', '/components/Traceback/subcomponents'],
          },
        ],
      },
      {
        title: 'Data & Tables',
        id: 'data-tables',
        route: ['/categories/data-tables'],
        items: [
          { label: 'Agreement', id: 'agreement', route: ['/components/Agreement/usage', '/components/Agreement/code'] },
          { label: 'Autograph', id: 'autograph', route: ['/components/Autograph/usage', '/components/Autograph/code'] },
          { label: 'Avatar', id: 'avatar', route: ['/components/Avatar/usage', '/components/Avatar/code'] },
          {
            label: 'FormattedNumber',
            id: 'formatted-number',
            route: [
              '/components/FormattedNumber/usage',
              '/components/FormattedNumber/code',
              '/components/FormattedNumber/subcomponents',
            ],
          },
          {
            label: 'GlobalFilter',
            id: 'global-filter',
            route: ['/components/GlobalFilter/usage', '/components/GlobalFilter/code'],
          },
          { label: 'Monologue', id: 'monologue', route: ['/components/Monologue/usage', '/components/Monologue/code'] },
          {
            label: 'NewTable',
            id: 'new-table',
            route: ['/components/NewTable/usage', '/components/NewTable/code', '/components/NewTable/subcomponents'],
          },
          {
            label: 'PdfViewer',
            id: 'pdf-viewer',
            route: ['/components/PdfViewer/usage', '/components/PdfViewer/code'],
          },
          {
            label: 'SpreadsheetV2',
            id: 'spreadsheet-v2',
            route: [
              '/components/SpreadsheetV2/usage',
              '/components/SpreadsheetV2/code',
              '/components/SpreadsheetV2/subcomponents',
            ],
          },
        ],
      },
      {
        title: 'Indicators',
        id: 'indicators',
        route: ['/categories/indicators'],
        items: [
          { label: 'Bubble', id: 'bubble', route: ['/components/Bubble/usage', '/components/Bubble/code'] },
          {
            label: 'List',
            id: 'list',
            route: ['/components/List/usage', '/components/List/code', '/components/List/subcomponents'],
          },
          {
            label: 'Tooltip',
            id: 'tooltip',
            route: ['/components/Tooltip/usage', '/components/Tooltip/code', '/components/Tooltip/subcomponents'],
          },
          {
            label: 'Progress',
            id: 'progress',
            route: ['/components/Progress/usage', '/components/Progress/code', '/components/Progress/subcomponents'],
          },
          {
            label: 'Shimmer',
            id: 'shimmer',
            route: ['/components/Shimmer/usage', '/components/Shimmer/code', '/components/Shimmer/subcomponents'],
          },
          { label: 'Status', id: 'status', route: ['/components/Status/usage', '/components/Status/code'] },
          {
            label: 'Tag',
            id: 'tag',
            route: ['/components/Tag/usage', '/components/Tag/code', '/components/Tag/subcomponents'],
          },
          { label: 'Loader', id: 'loader', route: ['/components/Loader/usage', '/components/Loader/code'] },
        ],
      },
      {
        title: 'Inputs',
        id: 'inputs',
        route: ['/categories/inputs'],
        items: [
          {
            label: 'ColorPalette',
            id: 'color-palette',
            route: [
              '/components/ColorPalette/usage',
              '/components/ColorPalette/code',
              '/components/ColorPalette/subcomponents',
            ],
          },
          { label: 'Combobox', id: 'combobox', route: ['/components/Combobox/usage', '/components/Combobox/code'] },
          {
            label: 'Dropdown',
            id: 'dropdown',
            route: ['/components/Dropdown/usage', '/components/Dropdown/code', '/components/Dropdown/subcomponents'],
          },
          { label: 'Field', id: 'field', route: ['/components/Field/usage', '/components/Field/code'] },
          {
            label: 'FilePicker',
            id: 'file-picker',
            route: ['/components/FilePicker/usage', '/components/FilePicker/code'],
          },
          {
            label: 'NewCheckbox',
            id: 'new-checkbox',
            route: ['/components/NewCheckbox/usage', '/components/NewCheckbox/code'],
          },
          {
            label: 'NewDatePicker',
            id: 'new-date-picker',
            route: [
              '/components/NewDatePicker/usage',
              '/components/NewDatePicker/code',
              '/components/NewDatePicker/subcomponents',
            ],
          },
          { label: 'NewInput', id: 'new-input', route: ['/components/NewInput/usage', '/components/NewInput/code'] },
          {
            label: 'NewTextArea',
            id: 'new-text-area',
            route: [
              '/components/NewTextArea/usage',
              '/components/NewTextArea/code',
              '/components/NewTextArea/subcomponents',
            ],
          },
          {
            label: 'NewRadio',
            id: 'new-radio',
            route: ['/components/NewRadio/usage', '/components/NewRadio/code'],
          },
          {
            label: 'NewSelect',
            id: 'new-select',
            route: ['/components/NewSelect/usage', '/components/NewSelect/code'],
          },
          {
            label: 'NewTypeahead',
            id: 'new-typeahead',
            route: ['/components/NewTypeahead/usage', '/components/NewTypeahead/code'],
          },
          { label: 'Search', id: 'search', route: ['/components/Search/usage', '/components/Search/code'] },
          {
            label: 'SelectableList',
            id: 'selectable-list',
            route: ['/components/SelectableList/usage', '/components/SelectableList/code'],
          },
          {
            label: 'SensitiveInput',
            id: 'sensitive-input',
            route: ['/components/SensitiveInput/usage', '/components/SensitiveInput/code'],
          },
          {
            label: 'TagManager',
            id: 'tag-manager',
            route: [
              '/components/TagManager/usage',
              '/components/TagManager/code',
              '/components/TagManager/subcomponents',
            ],
          },
        ],
      },
      {
        title: 'Messaging',
        id: 'messaging',
        route: ['/categories/messaging'],
        items: [
          { label: 'Alert', id: 'alert', route: ['/components/Alert/usage', '/components/Alert/code'] },
          { label: 'Banner', id: 'banner', route: ['/components/Banner/usage', '/components/Banner/code'] },
          {
            label: 'Blockquote',
            id: 'blockquote',
            route: ['/components/Blockquote/usage', '/components/Blockquote/code'],
          },
          {
            label: 'EmptyState',
            id: 'empty-state',
            route: ['/components/EmptyState/usage', '/components/EmptyState/code'],
          },
          {
            label: 'Message',
            id: 'message',
            route: ['/components/Message/usage', '/components/Message/code', '/components/Message/subcomponents'],
          },
        ],
      },
      {
        title: 'Navigation',
        id: 'navigation',
        route: ['/categories/navigation'],
        items: [
          {
            label: 'AppSwitcher',
            id: 'appswitcher',
            route: ['/components/AppSwitcher/code'],
          },
          {
            label: 'Breadcrumb',
            id: 'breadcrumb',
            route: [
              '/components/Breadcrumb/usage',
              '/components/Breadcrumb/code',
              '/components/Breadcrumb/subcomponents',
            ],
          },
          { label: 'Header', id: 'header', route: ['/components/Header/usage', '/components/Header/code'] },
          {
            label: 'HorizontalNav',
            id: 'horizontal-nav',
            route: [
              '/components/HorizontalNav/usage',
              '/components/HorizontalNav/code',
              '/components/HorizontalNav/subcomponents',
            ],
          },
          {
            label: 'LedgerWrapper',
            id: 'ledger-wrapper',
            route: [
              '/components/LedgerWrapper/usage',
              '/components/LedgerWrapper/code',
              '/components/LedgerWrapper/subcomponents',
            ],
          },
          {
            label: 'Pagination',
            id: 'pagination',
            route: ['/components/Pagination/usage', '/components/Pagination/code'],
          },
          {
            label: 'SideNav',
            id: 'side-nav',
            route: ['/components/SideNav/usage', '/components/SideNav/code', '/components/SideNav/subcomponents'],
          },
          {
            label: 'SubNav',
            id: 'sub-nav',
            route: ['/components/SubNav/usage', '/components/SubNav/code', '/components/SubNav/subcomponents'],
          },
          { label: 'Tracker', id: 'tracker', route: ['/components/Tracker/usage', '/components/Tracker/code'] },
          {
            label: 'VerticalNav',
            id: 'vertical-nav',
            route: [
              '/components/VerticalNav/usage',
              '/components/VerticalNav/code',
              '/components/VerticalNav/subcomponents',
            ],
          },
        ],
      },

      {
        title: 'Other',
        id: 'other',
        route: ['/categories/other'],
        items: [
          {
            label: 'Page',
            id: 'page',
            route: ['/components/Page/usage', '/components/Page/code', '/components/Page/subcomponents'],
          },
          {
            label: 'Li',
            id: 'li',
            route: ['/components/Li/usage', '/components/Li/code', '/components/Li/subcomponents'],
          },
          {
            label: 'InkOutliner',
            id: 'ink-outliner',
            route: [
              '/components/InkOutliner/usage',
              '/components/InkOutliner/code',
              '/components/InkOutliner/subcomponents',
            ],
          },
          { label: 'AppShell', id: 'app-shell', route: ['/components/AppShell/usage', '/components/AppShell/code'] },
          { label: 'Section', id: 'section', route: ['/components/Section/usage', '/components/Section/code'] },
        ],
      },
      {
        title: 'Deprecated',
        id: 'deprecated',
        route: ['/categories/deprecated'],
        items: [
          {
            label: 'Checkbox',
            id: 'deprecated-checkbox',
            route: ['/components/Checkbox/migration-guide', '/components/Checkbox/code'],
          },
          {
            label: 'DatePicker',
            id: 'deprecated-date-picker',
            route: ['/components/DatePicker/migration-guide', '/components/DatePicker/code'],
          },
          {
            label: 'DeprecatedDropdown',
            id: 'deprecated-deprecated-dropdown',
            route: ['/components/DeprecatedDropdown/migration-guide', '/components/DeprecatedDropdown/code'],
          },
          {
            label: 'DeprecatedDropdownItem',
            id: 'deprecated-deprecated-dropdown-item',
            route: ['/components/DeprecatedDropdownItem/migration-guide', '/components/DeprecatedDropdownItem/code'],
          },
          { label: 'Display', id: 'deprecated-display', route: ['/components/Display/code'] },
          {
            label: 'FormSection',
            id: 'deprecated-form-section',
            route: ['/components/FormSection/migration-guide', '/components/FormSection/code'],
          },
          {
            label: 'Heading1',
            id: 'deprecated-heading1',
            route: ['/components/Heading1/migration-guide', '/components/Heading1/code'],
          },
          {
            label: 'Heading2',
            id: 'deprecated-heading2',
            route: ['/components/Heading2/migration-guide', '/components/Heading2/code'],
          },
          {
            label: 'Heading3',
            id: 'deprecated-heading3',
            route: ['/components/Heading3/migration-guide', '/components/Heading3/code'],
          },
          {
            label: 'Heading4',
            id: 'deprecated-heading4',
            route: ['/components/Heading4/migration-guide', '/components/Heading4/code'],
          },
          {
            label: 'Input',
            id: 'deprecated-input',
            route: ['/components/Input/migration-guide', '/components/Input/code'],
          },
          {
            label: 'Ledger',
            id: 'deprecated-ledger',
            route: ['/components/Ledger/migration-guide', '/components/Ledger/code'],
          },
          {
            label: 'ModalContent',
            id: 'deprecated-modal-content',
            route: ['/components/ModalContent/migration-guide', '/components/ModalContent/code'],
          },
          {
            label: 'MultiStepModal',
            id: 'deprecated-multi-step-modal',
            route: ['/components/MultiStepModal/migration-guide', '/components/MultiStepModal/code'],
          },
          {
            label: 'Nav',
            id: 'deprecated-nav',
            route: ['/components/Nav/migration-guide', '/components/Nav/code'],
          },
          {
            label: 'Radio',
            id: 'deprecated-radio',
            route: ['/components/Radio/migration-guide', '/components/Radio/code'],
          },
          {
            label: 'Select',
            id: 'deprecated-select',
            route: ['/components/Select/migration-guide', '/components/Select/code'],
          },
          {
            label: 'Small',
            id: 'deprecated-small',
            route: ['/components/Small/migration-guide', '/components/Small/code'],
          },
          {
            label: 'Staffer',
            id: 'deprecated-staffer',
            route: ['/components/Staffer/migration-guide', '/components/Staffer/code'],
          },
          {
            label: 'Table',
            id: 'deprecated-table',
            route: ['/components/Table/migration-guide', '/components/Table/code', '/components/Table/subcomponents'],
          },
          {
            label: 'TextArea',
            id: 'deprecated-text-area',
            route: ['/components/TextArea/migration-guide', '/components/TextArea/code'],
          },
          {
            label: 'TileRow',
            id: 'deprecated-tile-row',
            route: ['/components/TileRow/migration-guide', '/components/TileRow/code'],
          },
          {
            label: 'Typeahead',
            id: 'deprecated-typeahead',
            route: ['/components/Typeahead/migration-guide', '/components/Typeahead/code'],
          },
        ],
      },
    ],
  },
  // Patterns
  {
    title: 'Patterns',
    id: 'patterns',
    route: ['/patterns'],
    children: [
      {
        label: 'AI Patterns',
        id: 'ai-patterns',
        route: ['/patterns/ai-patterns'],
      },
      {
        label: 'Cards',
        id: 'cards',
        route: ['/patterns/cards'],
      },
      {
        title: 'Data Dense Views',
        id: 'data-dense-views',
        route: ['/patterns/data-dense-views'],
        items: [
          {
            label: 'Tag Management',
            id: 'tag-management',
            route: ['/patterns/data-dense-views/tag-management'],
          },
          {
            label: 'Tracebacks',
            id: 'tracebacks',
            route: ['/patterns/data-dense-views/tracebacks'],
          },
          {
            label: 'Table Controls',
            id: 'table-controls',
            route: ['/patterns/data-dense-views/table-controls'],
          },
        ],
      },
      {
        title: 'Data Visualization',
        id: 'data-visualization',
        route: ['/patterns/data-visualization'],
        items: [
          {
            label: 'Charts',
            id: 'charts',
            route: ['/patterns/data-visualization/charts'],
          },
          {
            label: 'Network Visualization',
            id: 'network-visualization',
            route: ['/patterns/data-visualization/network-visualization'],
          },
        ],
      },
      {
        label: 'Forms',
        id: 'forms',
        route: ['/patterns/forms/usage', '/patterns/forms/code', '/patterns/forms/subcomponents'],
      },
      {
        title: 'Playful Moments',
        id: 'playful-moments',
        route: ['/patterns/playful-moments'],
        items: [
          {
            label: 'FullPageCelebration',
            id: 'fullpagecelebration',
            route: ['/components/FullPageCelebration/usage', '/components/FullPageCelebration/code'],
          },
          {
            label: '404 Page',
            id: '404-page',
            route: ['/patterns/playful-moments/404-page'],
          },
        ],
      },
      {
        label: 'Workflows',
        id: 'workflows',
        route: ['/patterns/workflows'],
      },
    ],
  },
  { type: 'Divider' },
  // Playroom
  {
    label: 'Playroom',
    id: 'playroom',
    route: ['https://ink.carta.com/playroom/#'],
    target: '_blank',
  },
  // Guidelines
  {
    title: 'Guidelines',
    id: 'guidelines',
    route: ['/guidelines'],
    children: [
      {
        label: 'Accessibility',
        id: 'accessibility',
        route: [
          '/guidelines/accessibility/standards',
          '/guidelines/accessibility/design-guidelines',
          '/guidelines/accessibility/auditing',
        ],
      },
      {
        label: 'Artificial Intelligence',
        id: 'artificial-intelligence',
        route: ['/guidelines/artificial-intelligence'],
      },
      {
        label: 'Email Guidelines',
        id: 'email-guidelines',
        route: ['/guidelines/email-guidelines/implementation', '/guidelines/email-guidelines/usage'],
      },
      {
        label: 'Internationalization',
        id: 'internationalization',
        route: [
          '/guidelines/internationalization/implementation',
          '/guidelines/internationalization/design-guidelines',
        ],
      },
      {
        label: 'Print Guidelines',
        id: 'print-guidelines',
        route: ['/guidelines/print-guidelines/implementation', '/guidelines/print-guidelines/usage'],
      },
      { label: 'Usability', id: 'usability', route: ['/guidelines/usability'] },
      { label: 'UX Writing', id: 'ux-writing', route: ['/guidelines/ux-writing'] },
    ],
  },
  // Developer Resources
  {
    title: 'Developer Resources',
    id: 'developer-resources',
    route: ['/developer-resources'],
    children: [
      { label: '101 Codemods', id: '101-codemods', route: ['/developer-resources/101-codemods'] },
      { label: '101 Playroom', id: '101-playroom', route: ['/developer-resources/101-playroom'] },
      { label: 'Ask-ink MCP', id: 'ask-ink-mcp', route: ['/developer-resources/ask-ink-mcp'] },
      {
        label: 'Hooks',
        id: 'hooks',
        route: [
          '/developer-resources/hooks',
          '/developer-resources/hooks/use-table-virtualizer',
          '/developer-resources/hooks/use-selectable',
          '/developer-resources/hooks/use-sort',
          '/developer-resources/hooks/use-ledger',
          '/developer-resources/hooks/use-formatted-date',
        ],
      },
      { label: 'Ink Linter', id: 'ink-linter', route: ['/developer-resources/ink-linter'] },
      // TEMP: Remove usage page until auth is back
      // { label: 'Usage', id: 'usage', route: ['/usage'] },
      { label: 'Testing in Ink', id: 'testing-in-ink', route: ['/developer-resources/testing-in-ink'] },
    ],
  },
  { type: 'Divider' },
  // Contribute, Connect, Preferences
  {
    title: 'Contribute',
    id: 'contribute',
    route: ['/contribute'],
    children: [
      { label: 'Adding Guides', id: 'adding-guides', route: ['/contribute/adding-guides'] },
      { label: 'Adding Code', id: 'adding-code', route: ['/contribute/adding-code'] },
      { label: 'Code Style', id: 'code-style', route: ['/contribute/code-style'] },
      { label: 'Testing', id: 'testing', route: ['/contribute/testing'] },
      { label: 'Issues Request', id: 'issues-request', route: ['/contribute/issues-request'] },
    ],
  },
  {
    label: 'Legacy Docs',
    id: 'legacy-docs',
    route: ['https://ink-old.carta.com/'],
    target: '_blank',
  },
  { label: 'Connect', id: 'connect', route: ['/connect'] },
  { label: 'Preferences', id: 'preferences', route: ['/preferences/'] },
  { type: 'Divider' },
  // Ink Labs
  {
    label: 'Ink Labs',
    id: 'ink-labs',
    route: ['https://go/inklabs'],
    target: '_blank',
    bubble: 'New',
  },
  { type: 'Divider' },
] as const;
